import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid";
import { FIELD_TYPE, META_DATA } from "app/constants";

@Component({
    selector: 'lfwms-custom-cell-renderer',
    templateUrl: './custom-cell-renderer.component.html',
    styleUrls: ['./custom-cell-renderer.component.css']
  })
  export class CustomCellRendererComponent implements ICellRendererAngularComp {

    public params: any;
    public cellValue: any;
    public statusIndicator: any;
    public statusCss = '';
    constructor() { }

    agInit(params: ICellRendererParams): void {
      this.init(params);
    }
    refresh(params: any): boolean {
      this.init(params);
      return true;
    }

    private init(params: any) {
      this.params = params;
      this.statusIndicator = params.value;
      // params.cellMetaData is undefined for some cells. Hence added a check before accessing its properties.
      // [UWP-55724][ERROR TypeError: Cannot read properties of undefined (reading 'type')]
      if (!params.cellMetaData) return;
      if(params.cellMetaData[META_DATA.TYPE] === FIELD_TYPE.TEXTFIELD){
        this.cellValue=params.value['cVal'];
        this.statusCss='statusMBOLError';
      }
      else{
        const dropdownValues = params.cellMetaData.values;
        this.statusCss= this.statusIndicator =='N' ? 'statusCellNormal' : 'statusCellShipped';
        if (params.cellMetaData['dbTableName'] === 'ORDERDETAIL') {
          this.statusCss = '';
        }
        if (params.value && dropdownValues.length!=0) {
          const cValue = dropdownValues.find(x => x.key === params.value.cVal);
          this.cellValue = cValue ? cValue.value : params.value.cVal;
        }
     }
    }

    public navigateToHyperlink() {
      this.params.context.componentParent.tableEditor.navigateToHyperlink(this.params);
    }
  }



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/custom-cell-renderer/custom-cell-renderer.component.ts